import { defineMessages } from 'react-intl';

export default defineMessages({
	unlinkModalTitle: {
		defaultMessage: 'Unlink this project?',
		description: 'Unlink project confirmation modal title',
		id: 'projects.list.unlink.confirmation.modal.title',
	},
	unlinkModalTitleGalaxia: {
		defaultMessage: 'Unlink this space?',
		description: 'Unlink space confirmation modal title',
		id: 'projects.list.unlink.confirmation.modal.title-galaxia',
	},
	unlinkModalDesc: {
		defaultMessage: `All help resources from the project {projectName} will be removed from the help center and will not show up in search.`,
		description: 'Unlink project confirmation modal description',
		id: 'projects.list.unlink.confirmation.modal.description',
	},
	unlinkModalDescGalaxia: {
		defaultMessage: `All help resources from the space {projectName} will be removed from the help center and will not show up in search.`,
		description: 'Unlink space confirmation modal description',
		id: 'projects.list.unlink.confirmation.modal.description-galaxia',
	},
	bulkUnlinkModalTitle: {
		defaultMessage: 'Unlink {number} projects?',
		description: 'Unlink project confirmation modal title in case of bulk unlinking',
		id: 'projects.list.bulk.unlink.confirmation.modal.title',
	},
	bulkUnlinkModalTitleGalaxia: {
		defaultMessage: 'Unlink {number} spaces?',
		description: 'Unlink space confirmation modal title in case of bulk unlinking',
		id: 'projects.list.bulk.unlink.confirmation.modal.title-galaxia',
	},
	bulkUnlinkModalDesc: {
		defaultMessage: `All help resources from these projects will be removed from the help center and will not show up in search.`,
		description: 'Unlink project confirmation modal description in case of bulk unlinking',
		id: 'projects.list.bulk.unlink.confirmation.modal.description',
	},
	bulkUnlinkModalDescGalaxia: {
		defaultMessage: `All help resources from these spaces will be removed from the help center and will not show up in search.`,
		description: 'Unlink space confirmation modal description in case of bulk unlinking',
		id: 'projects.list.bulk.unlink.confirmation.modal.description-galaxia',
	},
	unlinkModalConfirmButton: {
		defaultMessage: 'Unlink',
		description: 'Unlink project confirmation modal confirm button',
		id: 'projects.list.unlink.confirmation.modal.confirm.button',
	},
	unlinkModalCancelButton: {
		defaultMessage: 'Cancel',
		description: 'Unlink project confirmation modal cancel button',
		id: 'projects.list.unlink.confirmation.modal.cancel.button',
	},
});
